import apiService from './apiService';

export const onboardingService = {
  // ==================== Onboarding Progress ====================

  async getProgress(): Promise<any> {
    return apiService.get('/onboarding/progress');
  },

  async getChecklist(): Promise<any> {
    return apiService.get('/onboarding/checklist');
  },

  async completeStep(data: { step: string; data?: any }): Promise<any> {
    return apiService.post('/onboarding/complete', data);
  },

  async resetOnboarding(): Promise<any> {
    return apiService.post('/onboarding/reset');
  },

  // ==================== Onboarding Flow ====================

  async submitPersona(data: {
    persona: 'individual' | 'manager' | 'newJoiner' | 'newTeamMember' | 'admin' | 'organizationAdmin' | 'soloUser' | 'independentSolo' | 'organizationalSolo';
    role?: string;
    teamType?: string;
  }): Promise<any> {
    return apiService.post('/onboarding/persona', data);
  },

  async submitPreferences(data: {
    notificationPreferences?: any;
    privacySettings?: any;
    workingHours?: any;
  }): Promise<any> {
    return apiService.post('/onboarding/preferences', data);
  },

  async submitGoals(data: { goals: Array<{ title: string; category?: string; targetDate?: string }> }): Promise<any> {
    return apiService.post('/onboarding/goals', data);
  },

  // ==================== Milestones ====================

  async completeMilestone(milestone: string): Promise<any> {
    return apiService.post('/onboarding/milestone', { milestone });
  },

  async getMilestones(): Promise<any> {
    return apiService.get('/onboarding/milestones');
  },

  // ==================== Complete Onboarding ====================

  async completeOnboarding(data: {
    persona: string;
    skills?: string[];
    teamId?: string | null;
    teamName?: string | null;
    teamType?: string;
    organizationId?: string | null;
    organizationName?: string | null;
    avatarUrl?: string | null;
    notificationPreferences?: {
      emailNotifications?: boolean;
      emailFrequency?: string;
      checkInNotifications?: boolean;
      goalNotifications?: boolean;
      chatNotifications?: boolean;
      insightNotifications?: boolean;
      teamNotifications?: boolean;
    };
  }): Promise<any> {
    return apiService.post('/onboarding/complete-onboarding', data);
  },
};
